import mergeRecursive from "../../features/utils/mergeRecursive";

export function templateBookedPackageReport(obj) {
  let temp = {
    bookedBy: {
      firstName: "",
      lastName: "",
    },
    createdDate: "",
    updatedDate: "",
    packageInfoData: {
      product_name: ''
    },
    totalFarePrice: '',
    status: '',
  }
  
  // try {
  //   if(obj.flightData.booked_flights.length === 1) {
  //     console.log(obj);
  //     const data = mergeRecursive(JSON.parse(JSON.stringify(obj)),JSON.parse(JSON.stringify(temp)));
  //     console.log("temped - ",data);

  //   }
  // } catch(ex) {console.log("--")}
  const data = mergeRecursive(JSON.parse(JSON.stringify(obj)),JSON.parse(JSON.stringify(temp)));

  // console.log(" -== ",obj);
  let result = {
    customer: data.bookedBy.firstName + " " + data.bookedBy.lastName,
    bookingDate: data.createdDate,
    packageName: data.packageInfoData.product_name,
    amount: data.totalFarePrice,
    status: data.status
  }
  
  result = Object.values(result);

  // if(data.booked_flights.length > 1)
  //   result["returnDate"] = {
  //     date: data.flightData.booked_flights[1].origin.date,
  //     time: data.flightData.booked_flights[1].origin.time,
  //   }


  return result;
}

